<template>
  <v-container>
    <module-bar title="REPORTE DE ALQUILERES" icon="mdi-file-chart" />

    <v-row v-if="loadingData">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="1" size="60" />
      </v-col>
    </v-row>

    <v-row v-if="loadedData">
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar alquiler" single-line hide-details
          style="max-width: 400px" class="mb-5"></v-text-field>

        <v-card outlined>
          <v-data-table :search="search" :headers="headers" :items="items" :items-per-page="10" :mobile-breakpoint="800"
            @click:row="opendialogRent">

            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount }} S/
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogRent" persistent width="800">
      <v-card>
        <v-card-text>
          <rental-form schema="edit" :rent="rent" :click="click" title="EDITAR ALQUILER"
            @closeDialogRent="closeDialogRent" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import RentalForm from "../../components/Forms/rentalForm.vue";

export default {
  components: {
    ModuleBar,
    RentalForm,
  },

  beforeMount() {
    this.loadingData = true;
    this.loadedData = false;
    setTimeout(() => {
      this.$store.dispatch("findRentalsAction").then((res) => {
        this.items = res;
        this.loadingData = false;
        this.loadedData = true;
      });
    }, 500);
  },

  data() {
    return {
      loadingData: true,
      loadedData: false,
      dialogRent: false,
      rent: null,
      search: "",
      click: 0,
      headers: [
        {
          text: "Nombre",
          value: "name",
          width: "20%",
        },
        {
          text: "Monto",
          value: "amount",
          width: "10%",
        },
        {
          text: "Semana",
          value: "week",
          width: "10%",
        },

        {
          text: "Provincia",
          value: "location.name",
          width: "10%",
        },

        {
          text: "Distrito",
          value: "district",
          width: "10%",
        },

        {
          text: "Direccion",
          aling: "left",
          value: "address",
          width: "30%",
        },
      ],
      items: [],
    };
  },

  methods: {
    opendialogRent(value) {
      this.rent = value;
      this.dialogRent = true;
      this.click++;
    },

    closeDialogRent(data) {
      this.dialogRent = false;
      if (data) {
        let index = this.items.findIndex((v) => v.id == data.id);
        if (data.is_delete) {
          this.items.splice(index, 1);
          return;
        }
        this.items.splice(index, 1, data);
      }
    },
  },
};
</script>